import styled from "styled-components";

import MenuIcon from "../../../assets/img/icons/Elipsis.svg";
import AddIcon from "../../../assets/img/icons/addicon.svg";
import MinusIcon from "../../../assets/img/icons/minusIcon.svg";
import { Space } from "antd";
import FavouriteIcon from "../../Common/Components/ArticleFavouriteIcon";

/* social media  */
import ShareMenuPopup from "./ShareMenuPopup";
import ContentEngagementPill from "../../Common/Components/ContentEngagementPill";
import CMSPill from "../../Common/Components/CMSPill";
import { getImageUrl } from "../../../utils";
import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { openArticleSidebarPreview } from "../../GlobalActions";
import { getVersionId } from "./../../EmailBrowser/utils";

import { removeFavoriteArticle } from "../../Content/Favorites/actions";

const BlogItem = (props) => {
  const {
    articleId,
    title,
    description,
    website,
    tags,
    publishDate,
    smallBlog,
    imgUrl,
    imgHeight,
    isFav,
    isCMS,
    is_loading,
    is_removingFailed,
    isCurated,
    entities,
    link,
    companyLogo,
  } = props;

  const [imgWidth, setimgWidth] = useState({});
  const imgDiv = useRef(null);

  useEffect(() => {
    if (imgDiv.current) {
      let width = imgDiv.current.offsetWidth;
      setimgWidth(width);
    }
  }, []);

  return (
    <>
      <BlogItemWrapper SmallBlog={smallBlog}>
        <div className={`wrapper ${is_loading ? "disabled" : ""} ${is_removingFailed ? "remove-failed" : ""}`}>
          <div
            className="img-div"
            ref={imgDiv}
            onClick={() => {
              openArticleSidebarPreview({
                articleId,
                title,
                website,
                tags: entities,
                entities,
                publishDate,
              });
            }}
          >
            {/* uncomment this when using images and remove the upper inline height property */}
            <img
              src={getImageUrl(imgUrl, imgWidth, imgHeight, articleId)}
              alt=""
              className="img-responsive"
              style={{ height: imgHeight + "px" }}
            />
          </div>
          <img src={isCurated ? MinusIcon : AddIcon} className="add-icon" alt="add blog" />
          <div className="banner-left-icons">
            <Space>
              {isFav && (
                <i style={{ cursor: "pointer" }} onClick={() => removeFavoriteArticle(articleId)}>
                  <FavouriteIcon />
                </i>
              )}
              {isCMS && <CMSPill />}
            </Space>
          </div>
          <div className="content-div padding-lg">
            <div
              className="content"
              onClick={() => {
                openArticleSidebarPreview({
                  articleId,
                  title,
                  website,
                  tags: entities,
                  publishDate,
                  entities,
                });
              }}
            >
              <h4 className="title">{title}</h4>
              <div className="desc">
                <span className="website-link padding-sm">{website}</span>|
                <span className="published-time padding-sm">{publishDate}</span>
                {/* | <span className="tags padding-sm">{entities}</span> */}
              </div>
            </div>
            <div className="Blog-menu-icon">
              <ShareMenuPopup isFav={props.isFav} id={props.articleId} isCurated={props.isCurated} data={props}>
                <div className="padding-sm text-center">
                  <img src={MenuIcon} alt="menu" />
                </div>
              </ShareMenuPopup>
              {companyLogo ? (
                <div className="company-logo">
                  <img src={companyLogo} alt="logo" />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </BlogItemWrapper>
    </>
  );
};
export default BlogItem;

BlogItem.defaultProps = {
  imgUrl: "",
  title: "Article title goes here and can be up to two lines long if necessary, after that truncate…",
  website: "forbes.com",
  published: "2 min ago",
  tags: "Design, Strategy, Behavioural Economics",
  smallBlog: false,
};

const BlogItemWrapper = styled.div`
  height: 100%;
  .wrapper {
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    position: relative;
    border-radius: 8px;
    height: 100%;
    .img-div {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      img {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        min-width: 100%;
      }
    }
    .add-icon {
      position: absolute;
      top: 15px;
      right: 15px;
      :hover {
        cursor: pointer;
      }
    }
    .banner-left-icons {
      display: flex;
      position: absolute;
      top: 15px;
      left: 15px;
      padding-top: 3px;
      .article-fav-icon {
        img {
          -webkit-user-drag: none;
        }
      }
      .content-engagement-pill-wrapper {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
    .content-div {
      display: flex;
      .content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 21px;
        color: #424b50;
        min-height: 50px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
      .desc {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        .website-link {
          color: #db3725;
          font-family: "robotomedium", sans-serif;
          font-size: ${(props) => (props.SmallBlog ? "12px" : "14px")};
          padding-left: 0;
        }
        .published-time {
          color: #7e7e7e;
          font-size: ${(props) => (props.SmallBlog ? "12px" : "14px")};
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
        }
        .tags {
          color: #27ce0a;
          font-family: "robotomedium", sans-serif;
          font-weight: 400;
          font-size: ${(props) => (props.SmallBlog ? "12px" : "14px")};
          text-transform: capitalize;
        }
      }
      .Blog-menu-icon {
        align-self: flex-end;
        > div {
          cursor: pointer;
          img {
            .ant-popover .ant-popover-content .ant-popover-inner {
              border-radius: 10px;
            }
          }
        }
        .company-logo {
          align-self: flex-end;
          cursor: default;
          margin-bottom: -20px;
          padding-top: 20px;
          img {
            max-width: 40px;
          }
        }
      }
    }
  }
  .disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #ccc;
  }
  .remove-failed {
    /* for "disabled" effect */
    opacity: 1;
    background: #facfcf;
  }
`;
